var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container",
    attrs: {
      "data-type": "button"
    }
  }, [_c('button', {
    staticClass: "button social facebook",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.share('facebook');
      }
    }
  }, [_c('span', [_vm._v("Facebook")])]), _c('button', {
    staticClass: "button social telegram",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.share('telegram');
      }
    }
  }, [_c('span', [_vm._v("Telegram")])]), _c('button', {
    staticClass: "button social incontact",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.share('vk');
      }
    }
  }, [_c('span', [_vm._v("VK")])]), _c('button', {
    staticClass: "button social twitter",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.share('twitter');
      }
    }
  }, [_c('span', [_vm._v("twitter")])]), _c('button', {
    staticClass: "button social classmates",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.share('ok');
      }
    }
  }, [_c('span', [_vm._v("OK")])]), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }